import { SET_BLOCK_FEE_HISTORY, SET_FEES } from './action'

const initialState = {
  blockFeeHistory: {},
  fees: [],
  transferFee: 0,
}

const getTransferFee = fees => {
  for (let i = 0, len = fees.length; i < len; i++) {
    const feeObj = fees[i] || {}
    if (feeObj.fixed_fee_params) {
      return feeObj.fixed_fee_params.fee / 10 ** 8
    }
  }

  return 0
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_BLOCK_FEE_HISTORY:
      return {
        ...state,
        blockFeeHistory: action.data,
      }

    case SET_FEES:
      return {
        ...state,
        fees: action.data,
        transferFee: getTransferFee(action.data),
      }

    default:
      return state
  }
}
